export default (email = '') => {
  return email.toLowerCase().endsWith('@sony.com') || email.toLowerCase().endsWith('.sony.com');
};
